import { render, staticRenderFns } from "./AboutUs.vue?vue&type=template&id=8b00085a&"
var script = {}
import style0 from "./AboutUs.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports